import { HTMLAttributes } from 'react'

import { ThemeProps } from '@/contexts/theme/Theme'

import { cn } from '@/lib/utils'

export type BurgerProps = HTMLAttributes<HTMLSpanElement> &
  Partial<{
    theme: ThemeProps['theme']
    active: boolean
  }>

const Burger = ({
  theme = 'light',
  active,
  className,
  ...props
}: BurgerProps) => {
  return (
    <button
      className={cn(
        'group relative z-10',
        'h-[18px] w-[5rem]',
        'flex items-center justify-center gap-[0.5rem]',
        className
      )}
      {...props}
    >
      <span
        className={cn(
          'absolute z-10 h-full w-full rounded-xl',
          'transform-cpu transition-all duration-300 ease-out-cubic group-hover:scale-[1.1]',
          [
            {
              'bg-white/10': theme === 'dark',
              'bg-black/10': theme === 'light' || active
            }
          ]
        )}
      />
      <span
        className={cn(
          'relative z-20',
          'block size-[0.5rem] rounded-full',
          'transform-cpu transition-transform duration-500 ease-in-out-cubic group-hover:translate-x-1',
          [
            {
              'bg-blue-900': theme === 'dark',
              'bg-black': theme === 'light',
              hidden: active
            }
          ]
        )}
      ></span>
      <span
        className={cn('relative z-20', 'block size-[0.5rem] rounded-full', [
          {
            'bg-white': theme === 'dark',
            'bg-black': theme === 'light',
            'bg-transparent': active
          }
        ])}
      ></span>
      <span
        className={cn(
          'relative z-20',
          'block size-[0.5rem] rounded-full',
          'transform-cpu transition-transform duration-500 ease-in-out-cubic group-hover:-translate-x-1',
          [
            {
              'bg-white': theme === 'dark',
              'bg-black': theme === 'light',
              hidden: active
            }
          ]
        )}
      ></span>
      <span
        className={cn(
          'absolute left-1/2 top-1/2 z-30 block h-[0.5rem] origin-center -translate-x-1/2 -translate-y-1/2 content-normal rounded-full transition-all duration-500 ease-out-cubic backface-hidden',
          'pointer:w-[0.5rem]',
          'group-hover:scale-x-75 touch:w-[2.5rem]',
          [
            {
              'bg-black pointer:w-[2.5rem]': active
            }
          ]
        )}
      ></span>
    </button>
  )
}

export default Burger
